/*
 * 2020-2021 (C) - OneOverZero AG - MR,FG
 */
import { default as i18n } from "i18next";
import I18nextBrowserLanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-http-backend";

const instance = i18n;

const debug = !(
  import.meta.env.REACT_APP_ENVIRONMENT_NAME === "prod" ||
  import.meta.env.REACT_APP_ENVIRONMENT_NAME === "test"
);
instance
  .use(initReactI18next) // bind react-i18next to the instance
  .use(I18nextBrowserLanguageDetector)
  .use(Backend)
  .init({
    supportedLngs: ["de", "en", "it", "fr", "ua", "nl"],
    nonExplicitSupportedLngs: true,
    fallbackLng: "de",
    debug,
    initImmediate: false,
    ns: ["main"],
    defaultNS: "main",
    fallbackNS: "main",
    backend: {
      loadPath: import.meta.env.BASE_URL + "/locales/{{lng}}/{{ns}}.json",
    },

    interpolation: {
      escapeValue: false, // not needed for react!!
      /*format: i18NextFormatFunction,*/
    },
    react: {
      transSupportBasicHtmlNodes: true,
      transKeepBasicHtmlNodesFor: ["br", "strong", "i", "p", "ul", "li", "a"],
      useSuspense: false,
      // react i18next special options (optional)
      // override if needed - omit if ok with defaults
      /*
        bindI18n: 'languageChanged',
        bindI18nStore: '',
        transEmptyNodeValue: '',
      */
    },

    /**
     * I18n language detector. @See https://github.com/i18next/i18next-browser-languageDetector
     */
    detection: {
      order: ["localStorage", "navigator"],
      lookupLocalStorage: "robinz-language",
      caches: ["localStorage"],
    },
  });

export default instance;
